import {Button, Stack, Link as Link2} from '@chakra-ui/react';
import {motion} from 'framer-motion';
import React, {useState} from 'react';
import {Link, useLocation, useSearchParams, useNavigate} from 'react-router-dom';
import {HomeOptionsLink} from '../../../constants/hom-options';

const MotionedStack = motion(Stack);

const Togglebar = ({scrollToTop}) => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const param = location.pathname.indexOf("the-outer-join") != -1 ? 'The Outer Join' : "Running Through Walls";
    const [show, setShow] = useState(true);

    return (
        <>
            <MotionedStack
                direction={'row'}
                float={{base: "left", lg: "right"}}
                borderRadius={'full'}
                mx={'auto'}
                maxWidth={'335px'}
                w={'full'}
                bg={'white'}
                position={'relative'}
                height={{base: '44px'}}
                alignItems={'center'}
                p={'5px 6px'}
                overflow={'scroll'}
                sx={{
                    MsOverflowStyle: 'none' /* IE and Edge */,
                    scrollbarWidth: 'none' /* Firefox */,
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                }}
                spacing={[0, 1]}
            >
                {[{href: '/podcasts/running-through-walls', title: "Running Through Walls"},{href: '/podcasts/the-outer-join', title: "The Outer Join"}].map((item, key) => {
                    return (
                        <Button
                            sx={{
                                px: ['10px', '20px'],
                            }}
                            fontSize={['.75rem', '10px', '13px']}
                            key={key}
                            isActive={param === item.title} 
                            display={'flex'}
                            // as={Link}
                            // to={`${item.href}`}
                            height={{base: '36px'}}
                            onClick={() => {navigate(item.href); scrollToTop()}}
                        >
                            {item.title}
                        </Button>
                    );
                })}
            </MotionedStack>
        </>
    );
};

export default Togglebar;
